export const EXPENSES_CREATE_REQUEST = 'EXPENSES_CREATE_REQUEST'
export const EXPENSES_CREATE_SUCCESS = 'EXPENSES_CREATE_SUCCESS'
export const EXPENSES_CREATE_FAIL = 'EXPENSES_CREATE_FAIL'
export const EXPENSES_CREATE_RESET = 'EXPENSES_CREATE_RESET'


export const LIST_EXPENSES_REQUEST = 'LIST_EXPENSES_REQUEST'
export const LIST_EXPENSES_SUCCESS = 'LIST_EXPENSES_SUCCESS'
export const LIST_EXPENSES_FAIL = 'LIST_EXPENSES_FAIL'
export const LIST_EXPENSES_RESET = 'LIST_EXPENSES_RESET'

export const EXPENSES_DELETE_REQUEST = 'EXPENSES_DELETE_REQUEST'
export const EXPENSES_DELETE_SUCCESS = 'EXPENSES_DELETE_SUCCESS'
export const EXPENSES_DELETE_FAIL = 'EXPENSES_DELETE_FAIL'

export const EXPENSES_UPDATE_REQUEST = 'EXPENSES_UPDATE_REQUEST'
export const EXPENSES_UPDATE_SUCCESS = 'EXPENSES_UPDATE_SUCCESS'
export const EXPENSES_UPDATE_FAIL = 'EXPENSES_UPDATE_FAIL'
export const EXPENSES_UPDATE_RESET = 'EXPENSES_UPDATE_RESET'

export const EXPENSES_DETAILS_REQUEST = 'EXPENSES_DETAILS_REQUEST'
export const EXPENSES_DETAILS_SUCCESS = 'EXPENSES_DETAILS_SUCCESS'
export const EXPENSES_DETAILS_FAIL = 'EXPENSES_DETAILS_FAIL'


export const LIST_PAID_ENUMS_REQUEST = 'LIST_PAID_ENUMS_REQUEST'
export const LIST_PAID_ENUMS_SUCCESS = 'LIST_PAID_ENUMS_SUCCESS'
export const LIST_PAID_ENUMS_FAIL = 'LIST_PAID_ENUMS_FAIL'
export const LIST_PAID_ENUMS_RESET = 'LIST_PAID_ENUMS_RESET'